import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const FilterContainer = ({ className, ...props }) => {
  return <div {...props} className={cn(styles.root, className)} />;
};

export default FilterContainer;
